import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FormikWysiwygField } from '../../../Formik'
import Text from '../../../Text'
import {
  CHATROOM_INPUT_FIELD_NAME_MESSAGE,
  CHATROOM_INPUT_WYSIWYG_MIN_HEIGHT,
} from '../../Chatroom.constants'
import { useChatroomInputWysiwygMaxHeight } from '../../ChatroomInputForm'

import * as styles from './ChatroomMessageEditFormEditor.module.css'

function ChatroomMessageEditFormEditor({
  inlineOver,
  isDragging,
  isFullScreen,
  isSubmitting,
  onDragInlineLeave,
  onDragInlineOver,
  onDropFile,
  onInit,
}) {
  const { t } = useTranslation()

  const wysiwygMaxHeight = useChatroomInputWysiwygMaxHeight(isFullScreen)

  const draggingClassName = classNames(styles.dragging, {
    [styles.over]: inlineOver,
  })

  const textClassName = classNames({ [styles.text]: inlineOver })

  return (
    <div
      {...(!isSubmitting ? { onDragLeaveCapture: onDragInlineLeave } : null)}
      className={styles.chatroomMessageEditFormEditor}
    >
      <FormikWysiwygField
        {...(!isSubmitting
          ? { onDragOver: onDragInlineOver, onDrop: onDropFile }
          : null)}
        enableInlineImageAttach
        enablePasteAutolink
        enableTables
        Field={Fragment}
        disabled={isSubmitting}
        maxHeight={wysiwygMaxHeight}
        minHeight={CHATROOM_INPUT_WYSIWYG_MIN_HEIGHT}
        name={CHATROOM_INPUT_FIELD_NAME_MESSAGE}
        skeletonHeight={CHATROOM_INPUT_WYSIWYG_MIN_HEIGHT}
        onInit={onInit}
      />
      {!isSubmitting && isDragging ? (
        <div className={draggingClassName}>
          <Text isSecondary className={textClassName}>
            {t('Chatroom.DropAsImageInTextKey')}
          </Text>
        </div>
      ) : null}
    </div>
  )
}

export default ChatroomMessageEditFormEditor
